import * as Yup from 'yup';

const ForgotPasswordSchema = Yup.object({
  username: Yup.string()
    .trim()
    .min(3, 'must be at least 3 characters long')
    .required('Please enter your registered email address.')
})


export default ForgotPasswordSchema;